<div class="wrapper" [dir]="elementDirection$ | async">
  <div class="header flex justify-content-between px-24 pt-24 pb-24">
    <div class="d-flex align-items-center">
      <div class="icon mr-16">
        <mat-icon [svgIcon]="'driver-license'"></mat-icon>
      </div>
      <div class="title t-title-semibold">{{ 'Upload document' | translate | async }}</div>
    </div>
    <mat-icon class="close" (click)="onClose()">close</mat-icon>
  </div>

  <div class="content px-24 py-24">
    <ng-container *ngIf="config$ | async as config">
      <fb-editor [config]="config" [form]="form"> </fb-editor>
    </ng-container>
  </div>

  <div class="buttons pt-24 pb-24">
    <button matRipple class="btn-cancel t-footnote-semibold" (click)="onClose()">Cancel</button>
    <button (click)="onSubmit()" [disabled]="!form.valid" matRipple class="btn-success t-footnote-semibold">
      Upload
    </button>
  </div>
</div>
